"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgLenght(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M14.667 0L20 5.333l-1.185 1.185-8.298 8.296.001.001L9.333 16 4 10.667l.149-.15 1.036-1.035 8.297-8.297zm-.001 2.369l-8.297 8.297 2.963 2.963 1.186-1.186-1.926-1.926 1.185-1.185 1.926 1.926 1.185-1.185-1.332-1.332 1.185-1.185 1.332 1.332 1.186-1.185-1.926-1.926 1.185-1.185 1.926 1.927 1.186-1.186z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Lenght')(SvgLenght);
//# sourceMappingURL=Lenght.js.map